import React, { useState, useEffect } from "react";
import { Col, Row, Container } from "react-bootstrap";
import PraticianCommission from "./PraticianCommission";
import BusinessProviderCommission from "./BusinessProviderCommission";
import PrescriberCommission from "./PrescriberCommission";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var Ristourne = function Ristourne() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(PrescriberCommission, {})
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          children: /*#__PURE__*/_jsx(PraticianCommission, {})
        })]
      })
    })
  });
};

export default Ristourne;